import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import BOTRequestsForm from './BOTRequestsForm';

class BOTRequestsContainer extends Component {
    constructor(props) {
        super(props);

        this.blankRequestTicket = {
            employeeId: this.props.singleEmployee ? parseInt(this.props.userEmployee.employeeId) : 0,
            teamId: this.props.singleEmployee ? parseInt(this.props.userEmployee.teamMembership) : 0,
            clientId: 0,
            requestId: 0,
            requestOther: '',
            connectivityId: 0,
            connectivityOther: '',
            priorityId: 0,
            timeSavedEstimate: 0,
            clientDirected: false,
            notes: '',
            // timestamp: String(new Date().toISOString()).substring(0, 10),
            statusId: 0,
            assignedEmployeeId: 0,
            priorityRankId: 0,
            timeEstimate: 0,
            completed: '',
            updateNotes: ''
        }
        this.state = {
            botRequestTickets: [],
            botRequestTicketId: 0,
            editRequestTicket: { ...this.blankRequestTicket },
            newRequestTicket: { ...this.blankRequestTicket },
            employees: [],
            teams: [],
            requests: [
                { key: 1, value: 'Rules Manager' },
                { key: 2, value: 'Script' },
                { key: 5, value: 'Morning Script' },
                { key: 3, value: 'Custom Report' },
                { key: 4, value: 'Other (User Defined)' }
            ],
            priorities: [
                { key: 1, value: 'Low' },
                { key: 2, value: 'Medium' },
                { key: 3, value: 'High' }
            ],
            statuses: [
                { key: 1, value: 'No Status' },
                { key: 2, value: 'Assigned' },
                { key: 3, value: 'Testing' },
                { key: 4, value: 'Completed' },
                { key: 5, value: 'Rejected' }
            ],
            priorityRanks: [
                { key: 1, value: 'Low' },
                { key: 2, value: 'Medium' },
                { key: 3, value: 'High' }
            ],
            isLoaded: false,
            selectedSortColumnIndex: -1,
            selectedSortAscending: true,
        };
        this.columns = [
            { name: 'Requestor', sort: 'alpha', key: 'lastName', singleEmployeeHide: true },
            { name: 'Assigned', sort: 'alpha', key: 'assignedLastName' },
            { name: 'Team', sort: 'alpha', key: 'teamName', singleEmployeeHide: true },
            { name: 'Client', sort: 'alpha', key: 'clientName' },
            { name: 'Request Category', sort: 'alpha', key: 'requestCategory' },
            { name: 'Requestor Priority', sort: 'numeric', key: 'priorityId' },
            { name: 'Time Saved', sort: 'numeric', key: 'timeSavedEstimate' },
            { name: 'Est. Time to Complete', sort: 'numeric', key: 'timeEstimate' },
            { name: 'Priority', sort: 'numeric', key: 'priorityId', desc: true, defaultSort: true },
        ]
    }


    handleSort = (colIndex) => {
        this.props.log('BOTRequestsContainer.js/handleSort (colIndex)', colIndex);
        if (!this.columns[colIndex].sort || this.props.singleEmployee) return;
        this.setState((prevState) => {
            const ascending = (colIndex === prevState.selectedSortColumnIndex) ? !prevState.selectedSortAscending : true;
            return {
                selectedSortColumnIndex: colIndex,
                selectedSortAscending: ascending,
                botRequestTickets: [...prevState.botRequestTickets].sort((a, b) => {
                    const a2 = (this.columns[colIndex].key != null && a[this.columns[colIndex].key] != null) ? a[this.columns[colIndex].key] : '';
                    const b2 = (this.columns[colIndex].key != null && b[this.columns[colIndex].key] != null) ? b[this.columns[colIndex].key] : '';
                    switch (this.columns[colIndex].sort) {
                        case "numeric":
                            return ascending ? a[this.columns[colIndex].key] - b[this.columns[colIndex].key]
                                : b[this.columns[colIndex].key] - a[this.columns[colIndex].key];
                        default:
                            return ascending ? a2.localeCompare(b2) : b2.localeCompare(a2)
                    }
                })
            }
        })
    }

    componentDidMount = () => {
        this.props.log('BOTRequestsContainer.js/componentDidMount');
        this.getRequestTickets();
        this.getEmployees();
        this.getTeams();
    }

    getEmployees = () => {
        this.props.log('BOTRequestsContainer.js/getEmployees');
        fetch('/api/employees/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        employees: results.data
                            .filter(employee => employee.active)
                            .map(employee => {
                                return ({
                                    employeeId: employee.employeeId,
                                    firstName: employee.firstName,
                                    lastName: employee.lastName
                                })
                            })
                            .sort((a, b) => a.lastName.localeCompare(b.lastName))
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getTeams = () => {
        this.props.log('BOTRequestsContainer.js/getTeams');
        fetch('/api/teams/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        teams: results.data
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getRequestTickets = () => {
        this.props.log('BOTRequestsContainer.js/getRequestTickets');
        const url = this.props.singleEmployee ? '/api/bot-requests-home/'+this.props.userEmployee.employeeId : '/api/bot-requests/';
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        botRequestTickets: results.data.map(item => {
                            return {...item, requestCategory: this.state.requests.filter(request => request.key === item.requestId)[0].value}
                        })
                    });
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditRequestTicket = (botRequestTicketId) => {
        this.props.log('BOTRequestsContainer.js/onEditRequestTicket (botRequestTicketId)', botRequestTicketId);
        const botRequestTicket = [...this.state.botRequestTickets].filter(item => item.id === botRequestTicketId)[0];
        this.setState(() => {
            return {
                botRequestTicketId: botRequestTicketId,
                editRequestTicket: {
                    employeeId: botRequestTicket.employeeId,
                    teamId: botRequestTicket.teamId,
                    clientId: botRequestTicket.clientId,
                    requestId: botRequestTicket.requestId,
                    requestOther: botRequestTicket.requestOther,
                    connectivityId: botRequestTicket.connectivityId,
                    connectivityOther: botRequestTicket.connectivityOther,
                    priorityId: botRequestTicket.priorityId,
                    timeSavedEstimate: botRequestTicket.timeSavedEstimate,
                    clientDirected: botRequestTicket.clientDirected,
                    notes: botRequestTicket.notes,
                    statusId: botRequestTicket.statusId,
                    assignedEmployeeId: botRequestTicket.assignedEmployeeId,
                    priorityRankId: botRequestTicket.priorityRankId,
                    timeEstimate: botRequestTicket.timeEstimate,
                    completed: botRequestTicket.completed,
                    updateNotes: botRequestTicket.updateNotes
                }
            }
        })
    }

    onDeleteRequestTicket = (botRequestTicketId) => {
        this.props.log('BOTRequestsContainer.js/onDeleteRequestTicket (botRequestTicketId)', botRequestTicketId);
        fetch('/api/bot-requests/' + botRequestTicketId, {
            method: 'DELETE',
            body: JSON.stringify({
                user: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getRequestTickets();
                    this.props.addToast('Request ticket deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete request ticket.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeRequestTicket = (e, type) => {
        this.props.log('BOTRequestsContainer.js/onChangeRequestTicket (e, type)', type, e.target.name, e.target.value, e.target.checked);
        e.persist();
        let thisRequestTicket = (type === 'edit') ? this.state.editRequestTicket : this.state.newRequestTicket;
        switch (e.target.name) {
            case "employees":
                const employeeId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisRequestTicket.employees.findIndex(item => item === employeeId);
                if (index > -1) thisRequestTicket.employees.splice(index, 1);
                if (e.target.checked) thisRequestTicket.employees.push(employeeId);
                break;
            case "clientDirected":
            case "clientDirected-edit":
                thisRequestTicket.clientDirected = e.target.value === "true" ? true : false;
                break;
            default:
                thisRequestTicket[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editRequestTicket: thisRequestTicket } : { newRequestTicket: thisRequestTicket };
        });
    }

    handleCancelRequestTicket = () => {
        this.props.log('BOTRequestsContainer.js/handleCancelRequestTicket');
        this.setState({
            editRequestTicket: { ...this.blankRequestTicket },
            botRequestTicketId: 0
        })
    }

    handleAddRequestTicket = (e) => {
        this.props.log('BOTRequestsContainer.js/handleAddRequestTicket');
        let employeeName = '';
        let teamName = '';
        let clientName = '';
        if (this.state.employees.findIndex(employee => employee.employeeId === parseInt(this.state.newRequestTicket.employeeId)) > -1) {
            employeeName = this.state.employees.filter(employee => employee.employeeId === parseInt(this.state.newRequestTicket.employeeId))[0].lastName + ', '+
                this.state.employees.filter(employee => employee.employeeId === parseInt(this.state.newRequestTicket.employeeId))[0].firstName;
        };
        if (this.state.teams.findIndex(team => team.id === parseInt(this.state.newRequestTicket.teamId)) > -1) {
            teamName = this.state.teams.filter(team => team.id === parseInt(this.state.newRequestTicket.teamId))[0].teamName;
        };
        if (this.props.clients.findIndex(client => client.id === parseInt(this.state.newRequestTicket.clientId)) > -1) {
            clientName = this.props.clients.filter(client => client.id === parseInt(this.state.newRequestTicket.clientId))[0].client;
        };
        console.log('x',employeeName,teamName,clientName)
        fetch('/api/bot-requests/', {
            method: 'POST',
            body: JSON.stringify({
                date: this.state.newRequestTicket.date,
                employeeId: this.state.newRequestTicket.employeeId,
                employeeName: employeeName,
                teamId: this.state.newRequestTicket.teamId,
                teamName: teamName,
                clientId: this.state.newRequestTicket.clientId,
                clientName: clientName,
                requestId: this.state.newRequestTicket.requestId,
                requestOther: this.state.newRequestTicket.requestOther,
                connectivityId: this.state.newRequestTicket.connectivityId,
                connectivityOther: this.state.newRequestTicket.connectivityOther,
                priorityId: this.state.newRequestTicket.priorityId,
                timeSavedEstimate: this.state.newRequestTicket.timeSavedEstimate,
                clientDirected: this.state.newRequestTicket.clientDirected,
                notes: this.state.newRequestTicket.notes,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newRequestTicket: { ...this.blankRequestTicket },
                    }, () => this.getRequestTickets());
                    this.props.addToast('Request ticket added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add request ticket.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditRequestTicket = () => {
        this.props.log('BOTRequestsContainer.js/handleEditRequestTicket');
        fetch('/api/bot-requests/' + this.state.botRequestTicketId, {
            method: 'PUT',
            body: JSON.stringify({
                date: this.state.editRequestTicket.date,
                employeeId: this.state.editRequestTicket.employeeId,
                teamId: this.state.editRequestTicket.teamId,
                clientId: this.state.editRequestTicket.clientId,
                requestId: this.state.editRequestTicket.requestId,
                requestOther: this.state.editRequestTicket.requestOther,
                connectivityId: this.state.editRequestTicket.connectivityId,
                connectivityOther: this.state.editRequestTicket.connectivityOther,
                priorityId: this.state.editRequestTicket.priorityId,
                timeSavedEstimate: this.state.editRequestTicket.timeSavedEstimate,
                clientDirected: this.state.editRequestTicket.clientDirected,
                notes: this.state.editRequestTicket.notes,
                statusId: this.state.editRequestTicket.statusId,
                assignedEmployeeId: this.state.editRequestTicket.assignedEmployeeId,
                priorityRankId: this.state.editRequestTicket.priorityRankId,
                timeEstimate: this.state.editRequestTicket.timeEstimate,
                completed: this.state.editRequestTicket.completed,
                updateNotes: this.state.editRequestTicket.updateNotes
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        botRequestTicketId: 0,
                        editRequestTicket: { ...this.blankRequestTicket },
                    }, () => this.getRequestTickets());
                    this.props.addToast('Request ticket updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update request ticket.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    render() {
        this.props.info('BOTRequestsContainer.js/render');
        return (
            // (this.state.isLoaded) ?
            //     <>
            <CollapseCard title="BackOffice Technology" open={this.props.singleEmployee ? false : true}>
                <BOTRequestsForm
                    {...this.props}
                    {...this.state}
                    onChange={this.onChangeRequestTicket}
                    onEdit={this.onEditRequestTicket}
                    onDelete={this.onDeleteRequestTicket}
                    handleAdd={this.handleAddRequestTicket}
                    handleEdit={this.handleEditRequestTicket}
                    handleCancel={this.handleCancelRequestTicket}
                    handleSort={this.handleSort}
                    columns={this.columns}
                />
            </CollapseCard>
            // </>
            // :
            // <h3>Loading...</h3>
        );

    }
}

export default BOTRequestsContainer;
